import { AppRouteRecordRaw } from '@/router/types'

export const loanManagementConfiguration: AppRouteRecordRaw[] = [
  {
    path: 'loanManagementConfiguration',
    name: 'loanManagementConfiguration',
    component: () => import('@/views/loanManagementConfiguration/index.vue'),
    meta: {
      title: '助贷管理配置'
    },
    children: [
      // 其他配置
      {
        path: 'otherConfig',
        name: 'otherConfig',
        component: () => import('@/views/loanManagementConfiguration/otherConfig/index.vue'),
        meta: {
          title: '其他配置'
        }
      }
    ]
  }
]
